export default __webpack_public_path__ + "img/04efd370b38891236c4d247d65c199b5.svg";